import { isAdminRole } from "../../utils/auth";
import AdminUserMaster from "./AdminUserMaster";
import UserMasterProfile from "./UserMasterProfile";

export default function UserMaster() {
  return isAdminRole() ? <AdminUserMaster /> : <UserMasterProfile />;
}
